// src/App.tsx
import Chat from "./components/chat/Chat";

function App() {
  console.log("🚀 Sistema inicializado en:", import.meta.env.VITE_STAGE);
  console.log("🔗 Conectando a API en:", import.meta.env.VITE_API_URL);
  return (
    <div className="min-h-screen bg-base-200">
      <Chat />
    </div>
  );
}

export default App;